import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=21155ab2&lang=pug&"
import script from "./WebCam.vue?vue&type=script&lang=js&"
export * from "./WebCam.vue?vue&type=script&lang=js&"
import style0 from "./WebCam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports